import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import EmailCapture from "./EmailCapture";
import { SOCIAL_LINKS } from "../config";

export default function Follow() {
    return (
        <section id="follow" className="scroll-mt-20 bg-rose text-blush">
            <div className="grid lg:grid-cols-2 max-w-[1600px] mx-auto">
                <div className="relative min-h-[340px] lg:min-h-[640px] overflow-hidden order-1">
                    <img
                        src="/images/follow-portrait.jpg"
                        alt="Mashi J seated in a chair on a wood floor"
                        loading="lazy"
                        className="absolute inset-0 h-full w-full object-cover"
                    />
                    <div className="absolute bottom-0 inset-x-0 p-6 md:p-10 bg-gradient-to-t from-rose via-rose/50 to-transparent">
                        <p className="font-display font-extrabold uppercase tracking-tight text-2xl md:text-3xl text-blush">
                            Mashi&nbsp;<span className="text-garden">J</span>
                        </p>
                        <p className="text-sm md:text-base text-blush mt-1.5">Graceful by choice. Unbreakable by nature.</p>
                    </div>
                </div>

                <div className="p-8 md:p-14 lg:p-20 flex flex-col justify-center order-2">
                    <Reveal>
                        <p className="text-[11px] md:text-xs uppercase tracking-[0.25em] text-lily mb-5 md:mb-7 flex items-center gap-3">
                            <span className="h-2 w-2 bg-lily" aria-hidden="true" />
                            02 — Follow
                        </p>
                        <h2 className="font-display font-extrabold uppercase leading-[0.9] tracking-[-0.02em] text-4xl md:text-6xl text-blush">
                            Get the full song
                        </h2>
                        <p className="mt-4 md:mt-6 text-base md:text-lg font-light text-blush max-w-md">
                            Join the list — the full song lands in your inbox, and right here.
                        </p>
                    </Reveal>

                    <Reveal delay={0.12}>
                        <div className="mt-8 max-w-xl">
                            <EmailCapture id="follow" variant="rose" />
                        </div>
                    </Reveal>

                    <Reveal delay={0.2}>
                        <div className="mt-12 pt-8 border-t border-blush/30">
                            <p className="text-[10px] md:text-[11px] uppercase tracking-[0.25em] text-lily mb-4">Follow along</p>
                            <ul className="flex flex-wrap gap-x-7 gap-y-3">
                                {SOCIAL_LINKS.map((s) => (
                                    <li key={s.name}>
                                        <a
                                            href={s.href}
                                            target="_blank"
                                            rel="noreferrer"
                                            data-testid={`follow-${s.name.toLowerCase().replace(/\s+/g, "-")}-link`}
                                            className="inline-flex items-center gap-1.5 text-sm md:text-base text-blush hover:text-lily transition-colors duration-200"
                                        >
                                            {s.name}
                                            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
